import { Route, Routes, useLocation, 
  // useNavigate

 } from "react-router-dom";
// import Landing from "./pages/pre-launch/landing";
// import About from "./pages/pre-launch/about";
// import Services from "./pages/pre-launch/services";
import NoPage from "./pages/NoPage";
// import ComingSoonLayout from "./components/layouts/ComingSoonLayout";
import Homepage from "./pages/web-pages/homepage";
import WebAppLay from "./components/layouts/WebAppLay";
import AgentLayout from "./components/layouts/AgentLayout";
import SignupOpt from "./pages/auth/SignupOpt";
import TenantSignup from "./pages/auth/TenantSignup";
import AgentSignup from "./pages/auth/AgentSignup";
import LandlordSignup from "./pages/auth/LandlordSignup";
import Signin from "./pages/auth/Signin";
import ForgotPass from "./pages/auth/ForgotPass";
import Otp from "./pages/auth/Otp";
import NewPass from "./pages/auth/NewPass";
import Residential from "./pages/web-pages/residential";
import Agents from "./pages/web-pages/agents";
import Developers from "./pages/web-pages/developers";
import Commercial from "./pages/web-pages/commercial";
import HouseView from "./pages/web-pages/HouseView";
import ViewAgents from "./pages/web-pages/ViewAgents";
import Property from "./pages/agent-dashboard/Property";
import Overview from "./pages/agent-dashboard/Overview";
import Agreement from "./pages/agent-dashboard/Agreement";
import Payment from "./pages/agent-dashboard/Payment";
import Settings from "./pages/agent-dashboard/Settings";
import { useEffect } from "react";
import AddProperty from "./pages/agent-dashboard/AddProperty";
import DevDash from "./pages/dev_dash/DevDash";
import DevSettings from "./pages/dev_dash/DevSettings";
import DevProperty from "./pages/dev_dash/DevProperty";
import DevCustomers from "./pages/dev_dash/DevCustomers";
import EditProperty from "./pages/agent-dashboard/EditProperty";
import AgentHouseView from "./components/agent-ui/AgentHouseView";
import DashLayout from "./components/layouts/DashLayout";
import ViewProperty from "./pages/dev_dash/ViewProperty";
import DevEstateView from "./pages/dev_dash/DevEstateView";
import AddEstate from "./pages/dev_dash/AddEstate";
import DevAddProp from "./pages/dev_dash/DevAddProp";
import DevAddCus from "./pages/dev_dash/DevAddCus";
import DevCusView from "./pages/dev_dash/DevCusView";
import DevSignup from "./pages/auth/DevSignup";
import DevHouseView from "./pages/web-pages/DevHouseView";

function App() {
  // const navigate = useNavigate();
  const pathname = useLocation().pathname;

  const checkActiveUser = () => {
    // const user = JSON.parse(localStorage.getItem("apk"));
    // if (user) {
    //   if(user?.data?.accountType === "Agent"){
    //     navigate("/agent/overview")
    //   }
    //   if(user?.data?.accountType === "Developer"){
    //     navigate("/dev_dash/dashboard")
    //   }
    // }
    // console.log(user);
  };

  useEffect(() => {
    checkActiveUser();
    // eslint-disable-next-line
  }, [pathname]);

  return (
    <div className="App">
      <Routes>
        {/* <Route element={<ComingSoonLayout />}>
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
        </Route> */}
        <Route element={<WebAppLay />}>
          <Route path="/" element={<Homepage />} />
          <Route path="/residential" element={<Residential />} />
          <Route path="/agents" element={<Agents />} />
          <Route path="/agents-details" element={<ViewAgents />} />
          <Route path="/house-view/:id" element={<HouseView />} />
          <Route path="/dev-view/:id" element={<DevHouseView />} />
          <Route path="/developers" element={<Developers />} />
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/auth/signin" element={<Signin />} />
          <Route path="/auth/signup-opt" element={<SignupOpt />} />
          <Route path="/auth/tenant-signup" element={<TenantSignup />} />
          <Route path="/auth/agent-signup" element={<AgentSignup />} />
          <Route path="/auth/dev-signup" element={<DevSignup />} />
          <Route path="/auth/landlord-signup" element={<LandlordSignup />} />
        </Route>
        <Route element={<AgentLayout />}>
          <Route path="/agent/overview" element={<Overview />} />
          <Route path="/agent/agreement" element={<Agreement />} />
          <Route path="/agent/property/house-view/:id" element={<AgentHouseView />} />
          <Route path="/agent/payment" element={<Payment />} />
          <Route path="/agent/property" element={<Property />} />
          <Route path="/agent/property/add" element={<AddProperty />} />
          <Route path="/agent/property/edit" element={<EditProperty />} />
          <Route path="/agent/settings" element={<Settings />} />
        </Route>
        <Route element={<DashLayout />}>
          <Route path="/dev_dash/dashboard" element={<DevDash />} />
          <Route path="/dev_dash/settings" element={<DevSettings />} />
          <Route path="/dev_dash/property" element={<DevProperty />} />
          <Route path="/dev_dash/property/single-view" element={<ViewProperty />} />
          <Route path="/dev_dash/estate/estate-view" element={<DevEstateView />} />
          <Route path="/dev_dash/estate/estate-add" element={<AddEstate />} />
          <Route path="/dev_dash/property/property-add" element={<DevAddProp />} />
          <Route path="/dev_dash/customers" element={<DevCustomers />} />
          <Route path="/dev_dash/customers/add" element={<DevAddCus/>} />
          <Route path="/dev_dash/customers/view" element={<DevCusView/>} />
        </Route>

        <Route path="/auth/forgot-password" element={<ForgotPass />} />
        <Route path="/auth/new-password" element={<NewPass />} />
        <Route path="/auth/otp" element={<Otp />} />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </div>
  );
}

export default App;
